import constantsValid from './constantsValid';
import errorMesseage from './errorMesseage';
import notification from './notification';

const wordsbooks = { constantsValid, errorMesseage, notification };

export default wordsbooks;
